<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Course Detail` : "Add Course Detail" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="12">
            <div id="app">
              <label>Objectives* </label>
              <vue-editor
                v-model.trim="form.objectives"
                :editorToolbar="customToolbar"
                :rules="[rules.required]"
              ></vue-editor>
            </div>
          </v-col>
          <v-col cols="12">
            <div id="app">
              <label>Outcomes* </label>
              <vue-editor
                v-model.trim="form.outcomes"
                :editorToolbar="customToolbar"
                :rules="[rules.required]"
              ></vue-editor>
            </div>
          </v-col>
          <v-col cols="12" v-if="sub_type != 'Theory'">
            <div id="app">
              <label>Experiments </label>
              <vue-editor
                v-model.trim="form.experiments"
                :editorToolbar="customToolbar"
                :rules="[rules.required]"
              ></vue-editor>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    course_detail: {
      type: Object,
      default: () => {},
    },
    departments: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    course_id: {
      type: Number,
      default: () => null,
    },
    sub_type: {
      type: String,
      default: () => "",
    }
  },
  components: {},
  data() {
    return {
      rules,
      form: {},
      customToolbar: [
        ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ size: ["small", "normal", "large", "huge"] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: [] }],
        [{ script: "sub" }, { script: "super" }],
        [{ color: [] }, { background: [] }],
        ["clean"],
      ],
    };
  },
  computed: {},
  created() {
    if (this.edit) {
      this.form = { ...this.course_detail };
    }
  },
  methods: {
    save() {
      this.form.course_id = this.course_id;
      if (!this.$refs.form.validate()) return;

      if (this.edit) {
        this.$emit("update", this.form);
      } else {
        this.form.active = true;
        this.$emit("create", this.form);
      }
    },
  },
};
</script>

<style scoped></style>
